import { createProfessionalExporter } from '../../../utils/professionalExport';

const headers = ['Branch Name', 'Location', 'Manager', 'Phone', 'Members', 'Status'];

function formatStatus(status) {
  return status.charAt(0).toUpperCase() + status.slice(1);
}

const exporter = createProfessionalExporter({
  title: 'Branch List',
  headers,
  slug: 'branches',
  getRows: (list) =>
    list.map((b) => [
      b.name,
      b.location,
      b.manager,
      b.phone,
      b.members,
      formatStatus(b.status),
    ]),
  getSummary: (list) => [
    `Total branches: ${list.length}`,
    `Active: ${list.filter((b) => b.status === 'active').length}`,
    `Total members: ${list.reduce((sum, b) => sum + b.members, 0)}`,
  ],
});

export const printBranchList = (data) => exporter.print(data);
export const exportBranchCsv = (data) => exporter.csv(data);
export const exportBranchExcel = (data) => exporter.excel(data);
export const exportBranchPdf = (data) => exporter.pdf(data);
export const exportBranches = (data) => exporter.export(data);
